/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2025-03-08 14:33:12
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React from "react";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import QRCode from "qrcode.react";
import Barcode from "react-barcode";
import "./index.css";
import { BsyConfig } from "../../global/BsyConfig";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyDatePicker from "../BsyDatePicker";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
export default class BsyTextEditor extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-text",
      inputCls: "x-input",
      // width: 350,
      height: 30,
      allowBlank: !0,
      triggerEvent: !1,
      noRepeat: !1,
      title: null,
      textCent: !1,
      alertinfo: {
        icon: "success",
        tip: React.language("set.reminder.content"),
      },
      onValidateSuccess: null,
      onValidateFail: null,
      onAfterValidate: null,
      onBeforeEdit: null,
      onAfterEdit: null,
      onStopEdit: null,
      //触发拷贝
      onClipboard: null,
      onFormEvent: null,
      onKeyUp: null,
      autofocus: !1, //自动获取焦点，简单说就是此控件一直拥有焦点
      value: "",
      waterMark: "",
      inputTag: "input",
      ...props,
    });
    this.state = {
      value: this.options.value,
      showImage: 0,
    };
    this.input = React.createRef();
    this.element = React.createRef();
    this.imagePane = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.onlyTrigger = false;
    this.defaultHeight = this.options.css.height;
    this.errorTipText = "";
    // console.log(`BsyTextEditor ${this.uuid} ${this.options.value}`)
  }

  _init = () => {
    let opt = this.options;
    let value = BsyUtils.isObjectEmpty(this.options.value)
      ? null
      : BsyUtils.toStringDetailed(opt.value);
    this.value = value;
    this.setState({
      value: value,
    });
  };

  handleChange(event) {
    this.value = event.target.value;
    this.setState({ value: this.value, showImage: true });
    if (
      this.value &&
      this.value.trim() &&
      /^\d{2}:\d{2}:\d{2}$/.test(this.value)
    ) {
      const dateStr = `${dayjs().format("YYYY-MM-DD")} ${this.value}`;
      const date = dayjs(dateStr).toDate();
      if (dayjs(dateStr, "YYYY-MM-DD HH-mm-ss").isValid() && date) {
        this.datePicker?.updateDate(date);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (nextProps.value !== this.state.value) {
      if (BsyUtils.isObjectEmpty(nextProps.value)) {
        props.value = "";
      } else {
        props.value = BsyUtils.toStringDetailed(nextProps.value).trim();
      }
      this.value = props.value;
    }

    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState(
        {
          ...props,
        },
        () => {
          this.value = props.value;
        }
      );
    }
  }

  getValue = () => {
    if (this.value) {
      this.value = this.value + "";
    }

    return this.value ? this.value.trim() : "";
  };

  setValue = (v) => {
    v = BsyUtils.toStringDetailed(v).trim();
    v = BsyUtils.getAddressText(v);

    this.value = v + "";
    // this.setState({ value: this.value }, () => {
    //   this.checkValidate();
    // });
    this.setState({ value: this.value });
  };

  _onTriggerClick = (event) => {
    const { regex } = this.options;

    let that = this;

    if (that.showMsg) {
      return;
    }

    let constregex = BsyConfig().CONST.TEXT_TYPE_REGEXP;
    let format = "HH:mm:ss";
    if (regex === constregex.HMS) {
      format = "HH:mm:ss";
    } else if (regex === constregex.HM) {
      format = "HH:mm";
    }
    let val = this.state.value;
    if (val) {
      let TODAY = new Date();
      val =
        TODAY.getFullYear() +
        "/" +
        (TODAY.getMonth() + 1) +
        "/" +
        TODAY.getDate() +
        " " +
        this.state.value;
    } else {
      val = new Date();
    }
    let checksss = new Date(val);
    if (checksss instanceof Date && isNaN(checksss.getTime())) {
      checksss = new Date();
    }

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        that.showMsg = ref;
        return (
          <BsyDatePicker
            // startDate={that.std}
            // endDate={that.edd}
            ref={(el) => (that.datePicker = el)}
            format={format}
            date={checksss}
            onDateUpdate={(c, closeFloat) => {
              that.value = null;
              let Hours = c.getHours();
              Hours = Hours < 10 ? "0" + Hours : Hours;
              let Minutes = c.getMinutes();
              Minutes = Minutes < 10 ? "0" + Minutes : Minutes;
              let Seconds = c.getSeconds();
              Seconds = Seconds < 10 ? "0" + Seconds : Seconds;
              if (c) {
                if (regex == constregex.HMS) {
                  that.value = `${Hours}:${Minutes}:${Seconds}`;
                } else if (regex === constregex.HM) {
                  that.value = `${Hours}:${Minutes}`;
                }
              }
              that.setState({ value: that.value }, () => {
                if (closeFloat) ref.closeAlter();
              });
            }}
            onDateClear={() => {
              that.value = null;
              that.setState({ value: "" }, () => {
                ref.closeAlter();
              });
            }}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: "auto",
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.showMsg = null;
        that.hasFocus = false;
        BsyUtils.applyFunc(
          that,
          that.props.onStopEdit,
          [that.state.value, null, that],
          !1
        );
        return !1;
      },
    });
  };

  focus = () => {
    this.input.current.focus();
  };

  onFocus = (e) => {
    const { regex } = this.options;
    this.onlyTrigger = false;
    this.hasFocus = true;
    // x-input-focus
    e.target.classList.add("x-input-focus");
    this.lastValue = e.target.value;
    let constregex = BsyConfig().CONST.TEXT_TYPE_REGEXP;
    if (regex === constregex.HMS || regex === constregex.HM) {
      this._onTriggerClick(e);
      return;
    }
  };
  onBlur = (e) => {
    const { regex } = this.options;
    e.target.classList.remove("x-input-focus");

    this.value = BsyUtils.toStringDetailed(e.target.value).trim();
    this.setState({ value: this.value }, () => {
      if (this.isEnabled() && this._isScanEditable() && !this.onlyTrigger) {
        this.checkValidate();
        let constregex = BsyConfig().CONST.TEXT_TYPE_REGEXP;
        if (regex != constregex.HMS && regex != constregex.HM) {
          if (this.options.triggerEvent != 2) {
            this.hasFocus = false;
            BsyUtils.applyFunc(
              this,
              this.options.onStopEdit,
              [this.value ? this.value.trim() : "", null, this],
              !1
            );
          }
        }
      }
    });
  };

  componentWillUnmount() {
    const { subform, triggerEvent } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      if (triggerEvent === 2) {
        BsyUtils.applyFunc(
          this,
          this.options.onAfterEdit,
          [this.value ? this.value.trim() : "", null, this],
          !1
        );
      } else {
        BsyUtils.applyFunc(
          this,
          this.options.onStopEdit,
          [this.value ? this.value.trim() : "", null, this],
          !1
        );
      }
    }
  }

  setTextState = (a, errorTipText) => {
    let b = this.options;
    if (!this.input || !this.input.current) {
      return;
    }
    this.errorState = a;
    switch (a) {
      case BsyConfig().States.SUCCESS:
        this.input.current.classList.add(b.inputCls + "-success");
        this.errorTipText = "";
        break;
      case BsyConfig().States.ERROR:
        this.input.current.classList.add(b.inputCls + "-error");
        this.errorTipText = errorTipText;
        break;
      case BsyConfig().States.WARNING:
        this.input.current.classList.add(b.inputCls + "-warning");
        this.errorTipText = errorTipText;
        break;
      default:
        this.errorTipText = "";
        this.input.current.classList.remove(b.inputCls + "-success");
        this.input.current.classList.remove(b.inputCls + "-error");
        this.input.current.classList.remove(b.inputCls + "-warning");
        break;
    }
  };
  getTextState = () => {
    return this.errorState || 0;
  };

  checkValidate = () => {
    var a = this.options,
      b = this.getValue(),
      c = !0;

    if (BsyUtils.isEmpty(b)) {
      c = a.allowBlank;
      if (!c) {
        this.setInvalidateTypeText(React.language("item.required"));
      }
    } else if (!BsyUtils.isEmpty(a.regex)) {
      if (
        a.regex === "imageurl" ||
        a.regex === "qrcode" ||
        a.regex === "barcode"
      ) {
      } else {
        if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.ID) {
          c = BsyUtils.validateIdCard(b);
        } else {
          try {
            c = new RegExp(a.regex).test(b);
          } catch (a) {
            c = !1;
          }
        }
      }
      if (!c) {
        this.setInvalidateType("regex");
        if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.ID) {
          this.setInvalidateTypeText(React.language("widget.text.error.id"));
        } else if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.mobile) {
          this.setInvalidateTypeText(
            React.language("widget.text.error.mobile")
          );
        } else if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.tel) {
          this.setInvalidateTypeText(React.language("widget.text.error.tel"));
        } else if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.zip) {
          this.setInvalidateTypeText(React.language("widget.text.error.zip"));
        } else if (a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.email) {
          this.setInvalidateTypeText(React.language("widget.text.error.email"));
        } else if (
          a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.HMS ||
          a.regex === BsyConfig().CONST.TEXT_TYPE_REGEXP.HMS
        ) {
          // HMS
          this.setInvalidateTypeText(React.language("api.alias.format.tip"));
        } else {
          this.setInvalidateTypeText(React.language("widget.text.error.time"));
        }
      } else {
        this.setInvalidateTypeText("");
      }
    }
    return (
      c
        ? BsyUtils.applyFunc(this, a.onValidateSuccess, [b], !1) === !1 &&
          this.setTextState(BsyConfig().States.NORMAL)
        : BsyUtils.applyFunc(this, a.onValidateFail, [b], !1) === !1 &&
          this.setTextState(BsyConfig().States.ERROR),
      BsyUtils.applyFunc(this, a.onAfterValidate, [b, c], !1),
      c
    );
  };

  customCheckValidate = () => {
    return BsyUtils.applyFunc(
      this,
      this.props?.onCustomCheckValidate,
      [this.value ? this.value : "", null, this],
      !1
    );
  };

  onKeyUp = (e) => {
    let a = this.options;
    let b = this;
    if (b.isEnabled() && b._isScanEditable()) {
      if (this.field) {
        this.field.linkValue = this.field.value = this.value;
      }
      BsyUtils.applyFunc(
        b,
        a.onAfterEdit,
        [this.value ? this.value : "", null, this],
        !1
      );
      BsyUtils.applyFunc(b, a.onKeyUp, [e, b.value], !1);
      b.onlyTrigger = false;
      if (e.keyCode === 13 || e.which === 13) {
        b.onlyTrigger = true;
        b.hasFocus = false;
        BsyUtils.applyFunc(
          b,
          a.onStopEdit,
          [
            this.value ? this.value.trim() : "",
            {
              onenterClearText: function () {
                b._enterClearText();
              },
            },
            this,
          ],
          !1
        );
        // b.input && b.input.current && b.input.current.blur();
      }
    }
  };

  _isScanEditable = () => {
    var a = this.options;
    return !a.scan || a.scan.editable;
  };

  _enterClearText = () => {
    var a = this,
      b = this.options;
    if (b.enterClearText) {
      a.field.setValue(null);
    }
  };

  renderDisablePane = () => {
    const { value } = this.state;
    const { regex, textMode, generateQR, label, appId, formId, dataId } =
      this.options;
    let v = value;
    if (textMode === "password" && v) {
      v = BsyUtils.toStringDetailed(value).trim().replace(/./g, "*");
    }
    return (
      <div
        style={{
          position: "relative",
        }}
        className={generateQR ? " generate-qr " : ""}
      >
        <div
          style={{
            paddingRight: generateQR ? 30 : "",
          }}
          className={
            "bsy_form_item_disable " +
            (regex === "qrcode" ? "text-qrcode" : regex) +
            " text"
          }
          data-watermark={React.language("content.empty")}
          title={v}
        >
          {this.renderImage(v)}
        </div>
        {generateQR ? (
          <div
            className="btn"
            title={React.language("qrCode")}
            style={{
              position: "absolute",
              top: 6,
              right: 6,
              fontSize: 25,
              cursor: "pointer",
            }}
            onClick={() => {
              if (this.state.value) {
                new window.FX.QRPreview({
                  str: this.state.value,
                  label: label,
                  appId,
                  formId,
                  dataId,
                });
              } else {
                tipAlert({
                  type: "warning",
                  msg: React.language("subform.data.load.tip7"),
                });
              }
            }}
          >
            <i className="icon-qrcode"></i>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  select = () => {
    if (this.input && this.input.current) {
      this.input.current.select();
      this.input.current.focus();
    }
  };

  previewCanves = (cansv) => {
    const { dataId, widgetName, title, text } = this.options;
    new window.FX.FilePreview({
      files: [{ imageUrl: cansv.toDataURL() }],
      fieldName: widgetName,
      title: title || text,
      widgetType: "image",
      noDownload: true,
      dataId: dataId,
      currentItem: 0,
      autoClose: !1,
    });
  };

  drawImage2Canvas = (img) => {
    var imgWidth = img.naturalWidth;
    var imgHeight = img.naturalHeight;
    img.style.width = "";
    img.style.height = "";
    img.style.display = "flex";
    if (imgWidth > imgHeight) {
      if (imgWidth > 130) {
        img.style.width = "100%";
      } else {
        img.style.height = "auto";
      }
    } else {
      if (imgHeight > 130) {
        img.style.height = "100%";
      } else {
        img.style.height = "auto";
      }
    }
  };

  renderImage = (defaultVal) => {
    const { regex, dataId } = this.options;
    const { value, showImage } = this.state;
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return "";
    }

    switch (regex) {
      case "imageurl": {
        return (
          <div
            className={"img-preview " + regex}
            onClick={(e) => {
              e.stopPropagation();
              if (value && showImage) {
                new window.FX.FilePreview({
                  files: [{ imageUrl: value }],
                  noDownload: true,
                  dataId: dataId,
                  currentItem: 0,
                  autoClose: !1,
                });
              }
            }}
          >
            {showImage == 0 || showImage == 1 ? (
              <img
                style={{ display: "none" }}
                ref={this.imagePane}
                src={value}
                alt={value}
                onLoad={(e) => {
                  (e.currentTarget || e.target).style.display = "";
                  this.setState(
                    {
                      showImage: 1,
                    },
                    () => {
                      this.drawImage2Canvas(e.currentTarget || e.target);
                    }
                  );
                }}
                onError={(e) => {
                  (e.currentTarget || e.target).style.display = "none";
                  this.setState({
                    showImage: 2,
                  });
                }}
              />
            ) : (
              ""
            )}
          </div>
        );
      }
      case "qrcode": {
        return (
          <div
            className={"img-preview " + regex + "1"}
            onClick={(e) => {
              e.stopPropagation();
              let cansv = e.currentTarget.querySelector("canvas");
              if (cansv) {
                that.previewCanves(cansv);
              }
            }}
          >
            <QRCode
              value={value || ""} //value参数为生成二维码的链接
              size={80} //二维码的宽高尺寸
              fgColor={"#333"} //二维码的颜色
            />
          </div>
        );
      }
      case "barcode": {
        return (
          <div
            className={"img-preview " + regex}
            onClick={(e) => {
              e.stopPropagation();
              if (value) {
                let cansv = e.currentTarget.querySelector("canvas");
                if (cansv) {
                  that.previewCanves(cansv);
                }
              }
            }}
          >
            <Barcode
              renderer={"canvas"}
              value={value}
              displayValue={true}
              height={80}
            />
          </div>
        );
      }
      default:
        if (!BsyUtils.isObjectEmpty(defaultVal)) {
          if (Array.isArray(defaultVal)) {
            defaultVal = defaultVal.join("");
          }
          let mach = [];
          if (defaultVal) {
            defaultVal = defaultVal + "";
            let i = BsyConfig().CONST.TEXT_TYPE_REGEXP.URL;
            mach = defaultVal.split(new RegExp("(" + i + ")"));
          }

          return (
            <>
              {mach.map((dd, index) => {
                if (index % 2 !== 0) {
                  let a1 = dd;
                  if (BsyUtils.startWith(a1, "www")) {
                    a1 = "http://" + a1;
                  }
                  return (
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className="nest-link"
                      target="_blank"
                      rel="noreferrer"
                      href={a1}
                    >
                      {dd}
                    </a>
                  );
                }
                return dd;
              })}
            </>
          );
        }
        return "";
    }
  };

  btnEvent = () => {
    const { triggerEvent, triggerEventButton, eventAlert, alertinfo } =
      this.options;
    let that = this;
    if (triggerEvent == 2 && triggerEventButton) {
      if (eventAlert) {
        window.FX.Msg.alert({
          title: alertinfo.msg,
          type: alertinfo.icon,
          mode: "switchAlertShow",
          onOk: function () {
            BsyUtils.applyFunc(
              that,
              that.options.onFormEvent,
              [that.state.value, null, that],
              !1
            );
          },
        });
      } else
        BsyUtils.applyFunc(
          that,
          that.options.onFormEvent,
          [that.state.value, null, that],
          !1
        );
    }
  };

  renderBtn = () => {
    const {
      triggerEvent,
      triggerEventButton,
      label,
      generateQR,
      appId,
      formId,
      dataId,
    } = this.options;
    const { value, showImage } = this.state;
    if (generateQR) {
      return (
        <div
          className="btn"
          title={React.language("qrCode")}
          onClick={() => {
            if (this.state.value) {
              new window.FX.QRPreview({
                str: this.state.value,
                label: label,
                appId,
                formId,
                dataId,
              });
            } else {
              tipAlert({
                type: "warning",
                msg: React.language("subform.data.load.tip7"),
              });
            }
          }}
        >
          <i className="icon-qrcode"></i>
        </div>
      );
    }

    if (triggerEvent == 2) {
      let text = triggerEventButton;
      if (!triggerEventButton) {
        text = React.language("query");
      }

      return (
        <BsyIconBtn
          text={text}
          type="blue"
          click={this.btnEvent}
          mode={window.mode}
        ></BsyIconBtn>
      );
    }
  };

  render() {
    const {
      cssName,
      inputCls,
      widgetName,
      waterMark,
      hint,
      css,
      textMode,
      regex,
      inputTag,
    } = this.options;
    const { value, showImage,   } = this.state;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    if (this.element.current) {
      this.element.current.style.height = this.defaultHeight + "px";
      switch (regex) {
        case "barcode":
        case "qrcode": {
          if (value) {
            this.element.current.style.height = "auto";
          }
          break;
        }
        case "imageurl": {
          if (showImage === 1 && value) {
            this.element.current.style.height = "auto";
          }
          break;
        }

        default: {
          break;
        }
      }
    }

    return (
      <div className={cssName} style={css} ref={this.element}>
        <div className="text-context" style={{ display: "flex" }}>
          {/* {errorTipText ? <div className="error-tip">{errorTipText}</div> : ""} */}
          {inputTag === "textarea" ? (
            <textarea
              className={inputCls}
              style={{
                minHeight: css.height,
                width: "100%",
                resize: "none",
              }}
              ref={this.input}
              widgetname={widgetName}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.handleChange}
              onKeyDown={this.onkeyDown}
              onKeyUp={this.onKeyUp}
              // defaultValue={value||""}
              value={value || ""}
              placeholder={waterMark || hint ? waterMark || hint : ""}
            ></textarea>
          ) : (
            <input
              type={textMode || "text"}
              style={{
                height: css.height,
              }}
              className={inputCls}
              ref={this.input}
              widgetname={widgetName}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.handleChange}
              onKeyUp={this.onKeyUp}
              // defaultValue={value||""}
              value={value || ""}
              placeholder={waterMark || hint ? waterMark || hint : ""}
            />
          )}
          {this.renderBtn()}
        </div>

        {this.renderImage()}
      </div>
    );
  }
}
